import React, { useState, useEffect } from 'react';
import UtilInputs from 'src/common/components/UtilInputs';
import { labelsformLink, labelOrgans } from '../utils/list_data';
import { institutionsAPI } from 'src/api/modules/institutions';
import { organsAPI } from 'src/api/modules/organs';
import { profilesAPI } from 'src/api/modules/profiles';
import { usersAPI } from 'src/api/modules/users';
import SVG from 'react-inlinesvg';
import notice from 'src/common/components/Notice';
import { getAllOrgans } from 'src/utils/getSubOrganos';
import { Grid } from '@material-ui/core';
import TrashIcon from 'src/common/utils/TableColumnIcons/TrashIcon';
import CustomButton from 'src/common/components/CustomButton';
import SimpleDropdown from 'src/common/components/SimpleDropdown';
import { ICONS } from 'src/utils/icon-urls.utils';

const LinkUserTab = ({
	form,
	handleChange,
	disableUser,
	disableForm,
	myProfile,
	addOrgans,
	disableOrgan,
	assignOrgans,
	member,
	//onHandleMember,
	handleAddOrgan,
	onDelete,
}) => {
	const [organs, setOrgans] = useState([]);
	const [institutions, setInstitutions] = useState([]);
	const [profiles, setprofiles] = useState([]);

	useEffect(() => {
		getOrgans();
		getInstitutions();
		getProfiles();
	}, []);

	const getUser = () => {
		usersAPI
			.getUserIN(form.usuario)
			.then((response) => {
				const result = JSON.parse(response);

				if (result.usuario !== undefined) {
					if (result.conexion === 'exitosa') {
						let names = result.nombre.split(' ');
						let name = names[names.length - 1];
						let firstSurnameame = result.apellidos.split(' ')[0];
						let secondSurname = result.apellidos.split(' ')[1];
						form.nombre = name === undefined ? '' : name;
						form.apellidoPaterno =
							firstSurnameame === undefined ? '' : firstSurnameame;
						form.apellidoMaterno =
							secondSurname === undefined ? '' : secondSurname;
						form.correo = result.mail === undefined ? '' : result.mail;

						handleChange({
							target: { name: 'usuario', value: form.usuario },
						});
					} else notice('El usuario que busca no existe');
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const getProfiles = () => {
		profilesAPI
			.get('get')
			.then((response) => {
				if (response && response.length > 0) {
					let profilesFlag = [];
					response.forEach((ele) => {
						profilesFlag.push({
							value: ele.id,
							text: ele.nombre,
						});
					});
					setprofiles([...(profilesFlag || [])]);
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};

	const getInstitutions = () => {
		institutionsAPI
			.get('unidadAdministrativa')
			.then((response) => {
				if (response.length > 0) {
					let institutionsFlag = [];

					response.forEach((item) => {
						institutionsFlag.push({
							value: item.id,
							text: item.nombre.toUpperCase(),
						});
					});
					setInstitutions(institutionsFlag);
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};

	const getOrgans = () => {
		organsAPI
			.get('get')
			.then((response) => {
				if (response && response.length > 0) {
					setOrgans(getAllOrgans(response));
				}
			})
			.catch((e) => notice('Ocurrio un error al cargar órganos colegiados'));
	};

	return (
		<>
			{disableUser === false && myProfile === false && (
				<div className="ml-lg-3 mb-5">
					<h6>
						Al escribir el usuario y cambiar de campo, se autocompletan los
						datos.
						<SVG
							src={ICONS.CODE_WARNING}
							width="20px"
							height="30px"
							className="mb-2"
						/>
					</h6>
				</div>
			)}
			<UtilInputs
				formValues={form}
				inputValues={labelsformLink(
					disableUser,
					myProfile,
					profiles,
					institutions,
					disableOrgan,
					member.member
				)}
				onValuesChange={handleChange}
				onBlur={getUser}
			/>
			<h6 className={assignOrgans ? 'my-3 ml-lg-3 mb-4' : 'd-none'}>
				Asignación de Órganos Colegiados
			</h6>
			{!member.member && assignOrgans === true && (
				<UtilInputs
					formValues={addOrgans}
					inputValues={labelOrgans(organs, disableOrgan, myProfile)}
					onValuesChange={handleChange}
				/>
			)}
			{member.member && assignOrgans && addOrgans.organs && (
				<Grid container>
					<Grid item xs={12} md={5}>
						<h8 className="ml-lg-3">Órgano Colegiado</h8>
					</Grid>
					<Grid item xs={12} md={5}>
						<h9 className="ml-lg-4">Cargo</h9>
					</Grid>
				</Grid>
			)}
			{member.member &&
				assignOrgans &&
				addOrgans.organs &&
				addOrgans.organs.map((item, index) => (
					<div key={index}>
						<Grid container spacing={1} className="ml-lg-2">
							<Grid item xs={12} md={5}>
								<SimpleDropdown
									options={organs}
									value={item.value}
									onChange={(e) => handleChange(e, 'tree', index)}
								/>
							</Grid>
							<Grid item xs={12} md={5}>
								<SimpleDropdown
									options={[
										{ value: 'PR', text: 'Propietario' },
										{ value: 'SU', text: 'Suplente' },
									]}
									onChange={(e) => handleChange(e, 'cargo', index)}
									value={item.cargo}
								/>
							</Grid>
							<Grid container item xs={12} md={2} spacing={1}>
								<Grid item xs={12}>
									<TrashIcon onClick={() => onDelete(item.value)} />
								</Grid>
							</Grid>
						</Grid>
					</div>
				))}
			{member.member && assignOrgans && addOrgans.organs && (
				<Grid container item xs={3} mt={4}>
					<CustomButton
						style={{
							width: '100%',
							height: '100%',
							marginTop: '8px',
							marginLeft: '11px',
						}}
						mainText="Agregar"
						color="info"
						onClick={handleAddOrgan}
					/>
				</Grid>
			)}
		</>
	);
};

export default LinkUserTab;
